export const INITIAL_REDEEMABLE_ITEM_SET = new Set<string>('');
